module.exports = __webpack_public_path__ + "img/teacher.5ccda544.png";